<div *ngrxLet="dashboardSettings$ | async as dashboardSettings">
  <div class="d-flex align-items-center mb-md-0 mb-3 mx-1 my-2">
    <div
      class="d-flex mr-3 dashboard-back cursor-pointer"
      (click)="location.back()"
    >
      <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
    </div>
    <h1
      class="mb-0"
      i18n="
        AnalyticsDashboard|Analytics dashboard page title@@dashboardPageTitle"
    >
      Analytics Dashboard
    </h1>
  </div>

  @if ( dashboardSettings.dashboards?.articles?.enabled &&
  dashboardSettings.dashboards?.lists?.enabled) {
  <nav ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
    <ng-container ngbNavItem class="ml-2">
      <a
        ngbNavLink
        i18n="
          AnalyticsDashboard|Best Performing Lists
          Title@@bestPerformingListsTitle"
        >Best Performing Lists</a
      >
      <ng-template ngbNavContent
        ><epc-best-performing-lists></epc-best-performing-lists
      ></ng-template>
    </ng-container>
    <ng-container ngbNavItem>
      <a
        ngbNavLink
        i18n="
          AnalyticsDashboard|Best Performing Lists
          Title@@bestPerformingArticlesTitle"
        >Best Performing Articles</a
      >
      <ng-template ngbNavContent>
        <epc-best-performing-articles></epc-best-performing-articles>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
  } @else { @if (dashboardSettings.dashboards?.lists?.enabled) {
  <epc-best-performing-lists></epc-best-performing-lists>
  } @if (dashboardSettings.dashboards?.articles?.enabled) {
  <epc-best-performing-articles></epc-best-performing-articles>
  } }
</div>
